'use strict';

module.exports = {
  EMDB: require('../packages/emdb'),
  IsotopicDistribution: require('../packages/isotopic-distribution'),
  MF: require('../packages/mf-parser/src/MF.js'),
  Peptide: require('peptide'),
  Nucleotide: require('../packages/nucleotide')
};
